module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XnW0Xv/tc-custom/9781504062824.jpg?1701329260699",
      "alt": "This image is the cover for the book Oedipus Rex, The Oedipus Cycle"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Oedipus Rex, The Oedipus Cycle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A king tries in vain to avert a horrific fate in this epic tragedy, widely considered a masterpiece.")])]), _c('p', [_vm._v("Oedipus was warned that his destiny is for him to kill his father and marry his mother. So he fled his home and has now become the king of Thebes, taking the throne after the death of its previous occupant, Laius, and marrying his widow, Jocasta.")]), _vm._v(" But just as Laius long ago labored to defy a prophecy and ultimately failed, so will Oedipus, in this masterpiece by the great tragedian of ancient Greece.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sophocles, F. Storr\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sophocles is one of three ancient Greek tragedians whose plays have survived. His first plays were written later than or contemporary with those of Aeschylus, and earlier than or contemporary with those of Euripides.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0